module.exports = __webpack_public_path__ + "static/media/skill-seo-hero-2.476fd7aa.jpg";